import React, { useEffect, useState } from "react";
import "./Vendors.css";

const Vendors = () => {

    const [vendors, setVendors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);


const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteCode, setDeleteCode] = useState("");
const [deleteVendorId, setDeleteVendorId] = useState(null);
const [sendingDeleteCode, setSendingDeleteCode] = useState(false);
const [deletingVendor, setDeletingVendor] = useState(false);
const [downloadVendor, setDownloadVendor] = useState(false);
const [downloadingVendors, setDownloadingVendors] = useState(false);
const [deleteRecipientEmail, setDeleteRecipientEmail] = useState("");

const [showDownloadVendorModal, setShowDownloadVendorModal] = useState(false);
const [selectedDownloadVendor, setSelectedDownloadVendor] = useState("");


    const emptyForm = {
        vendor_name: "",
        contact_person: "",
        gst_number: "",
        phone_country_code: "+91",
        phone_number: "",
        whatsapp_country_code: "+91",
        whatsapp_number: "",
        date: "",
        email: "",
        address: "",
        city: "",
        state: "",
        country: "India",
        pincode: ""
    };

    const [formData, setFormData] = useState(emptyForm);


    // ----------------------------------
    // GET ALL VENDORS
    // ----------------------------------

    const fetchVendors = async () => {

        try {

            setLoading(true);

            const response = await fetch("/vendors");

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            setVendors(Array.isArray(data) ? data : []);

        } catch (error) {

            console.error("Error fetching vendors:", error);

            setVendors([]);

        } finally {

            setLoading(false);

        }
    };


    useEffect(() => {

        fetchVendors();

    }, []);


    // ----------------------------------
    // HANDLE INPUT
    // ----------------------------------

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

    };


    // ----------------------------------
    // ADD VENDOR
    // ----------------------------------

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            /*
             * Combine country code + phone number
             * before sending to backend.
             */
            const submitData = {
                ...formData,

                phone_number:
                    `${formData.phone_country_code}${formData.phone_number}`,

                whatsapp_number:
                    `${formData.whatsapp_country_code}${formData.whatsapp_number}`
            };

            /*
             * Remove separate country-code fields
             * because database already has only
             * phone_number and whatsapp_number.
             */
            delete submitData.phone_country_code;
            delete submitData.whatsapp_country_code;


            const response = await fetch("/vendors", {

                method: "POST",

                headers: {
                    "Content-Type": "application/json"
                },

                body: JSON.stringify(submitData)

            });


            const result = await response.json();


            if (!response.ok) {

                throw new Error(
                    result.message || "Failed to add vendor"
                );

            }


            alert(
                `Vendor added successfully!\nVendor ID: ${result.vendor_id}`
            );


            setFormData(emptyForm);

            setShowForm(false);

            fetchVendors();


        } catch (error) {

            console.error("Error adding vendor:", error);

            alert(error.message);

        }
    };



// ----------------------------------
// DELETE VENDOR
// ----------------------------------


const deleteVendor = async (vendorId) => {

    console.log("Delete clicked. Vendor ID:", vendorId);

    if (!vendorId) {
        alert("Vendor ID is missing. Please refresh the Vendors page.");
        return;
    }

    const confirmed = window.confirm(
        "Are you sure you want to delete this vendor?\n\n" +
        "A verification OTP will be sent to the vendor's registered email."
    );

    if (!confirmed) return;

    try {

        setSendingDeleteCode(true);

        const sendResponse = await fetch("/send-delete-code", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                vendor_id: String(vendorId).trim()
            })
        });

        const sendResult = await sendResponse.json();

        console.log("OTP response:", sendResult);

        if (!sendResponse.ok || !sendResult.success) {
            throw new Error(
                sendResult.message || "Failed to send OTP."
            );
        }

        setDeleteVendorId(String(vendorId).trim());

        setDeleteRecipientEmail(
            sendResult.email || ""
        );

        setDeleteCode("");

        setDownloadVendor(false);

        setShowDeleteModal(true);

        alert(
            sendResult.message ||
            "OTP sent to the vendor's registered email."
        );

    } catch (error) {

        console.error(
            "Send vendor OTP error:",
            error
        );

        alert(
            error.message ||
            "Unable to send verification OTP."
        );

    } finally {

        setSendingDeleteCode(false);

    }
};// ----------------------------------
// VERIFY CODE AND DELETE VENDOR
// ----------------------------------

// ----------------------------------
// VERIFY OTP
// DELETE VENDOR OR DOWNLOAD VENDORS
// ----------------------------------


const verifyDeleteCode = async () => {
    const enteredCode = deleteCode.trim();

    if (!/^\d{6}$/.test(enteredCode)) {
        alert("Please enter the 6-digit OTP.");
        return;
    }

    // =========================================
    // DOWNLOAD VENDOR EXCEL AFTER OTP VERIFICATION
    // =========================================
    if (downloadVendor) {
        const vendorId = String(deleteVendorId || "").trim();

        if (!vendorId) {
            alert("Selected vendor ID is missing. Please select the vendor again.");
            return;
        }

        try {
            setDownloadingVendors(true);

            const response = await fetch("/vendors/export-odoo", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    vendor_id: vendorId,
                    code: enteredCode
                })
            });

            if (!response.ok) {
                let message = "Failed to download vendor details.";

                try {
                    const result = await response.json();
                    message = result.message || message;
                } catch (error) {
                    // Response was not JSON
                }

                throw new Error(message);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = "vendors_craftcounter.xlsx";
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);

            setShowDeleteModal(false);
            setDeleteCode("");
            setDeleteVendorId(null);
            setDeleteRecipientEmail("");
            setDownloadVendor(false);
            setSelectedDownloadVendor("");

            alert("Vendor details downloaded successfully.");

        } catch (error) {
            console.error("Vendor export error:", error);
            alert(error.message || "Unable to download vendor details.");
        } finally {
            setDownloadingVendors(false);
        }

        return;
    }

    // =========================================
    // DELETE VENDOR AFTER OTP VERIFICATION
    // =========================================
    if (!deleteVendorId) {
        alert("Vendor information is missing. Please try again.");
        return;
    }

    try {
        setDeletingVendor(true);

        const response = await fetch(
            `/vendors/${encodeURIComponent(deleteVendorId)}`,
            {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    code: enteredCode
                })
            }
        );

        const result = await response.json();

        if (!response.ok) {
            throw new Error(
                result.message || "Invalid OTP or vendor deletion failed."
            );
        }

        setShowDeleteModal(false);
        setDeleteCode("");
        setDeleteVendorId(null);
        setDeleteRecipientEmail("");
        setDownloadVendor(false);

        alert("Vendor deleted successfully.");

        await fetchVendors();

    } catch (error) {
        console.error("Vendor OTP verification error:", error);
        alert(error.message || "Unable to delete vendor.");
    } finally {
        setDeletingVendor(false);
    }
};



    // ----------------------------------
    // DOWNLOAD VENDOR DETAILS
    // ----------------------------------
// ----------------------------------
// DOWNLOAD VENDOR DETAILS
// OTP VERIFIED DOWNLOAD
// ----------------------------------

// ----------------------------------
// OPEN DOWNLOAD VENDOR SELECTION
// ----------------------------------

const downloadVendorDetails = () => {

    if (!vendors || vendors.length === 0) {
        alert("No vendors available for download.");
        return;
    }

    setSelectedDownloadVendor("");
    setShowDownloadVendorModal(true);
};


// ----------------------------------
// SEND DOWNLOAD OTP TO SELECTED VENDOR
// ----------------------------------

const sendDownloadOTP = async () => {
    if (!selectedDownloadVendor) {
        alert("Please select a vendor.");
        return;
    }

    const selectedVendor = vendors.find(
        vendor =>
            String(vendor.vendor_id).trim() ===
            String(selectedDownloadVendor).trim()
    );

    if (!selectedVendor) {
        alert("Selected vendor was not found.");
        return;
    }

    if (!selectedVendor.email) {
        alert("This vendor does not have a registered email address.");
        return;
    }

    try {
        setSendingDeleteCode(true);

        const response = await fetch("/send-delete-code", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                vendor_id: String(selectedVendor.vendor_id).trim()
            })
        });

        const result = await response.json();

        if (!response.ok || !result.success) {
            throw new Error(
                result.message || "Failed to send OTP."
            );
        }

        // Preserve the selected vendor ID for OTP verification
        setDeleteVendorId(String(selectedVendor.vendor_id).trim());
        setDeleteRecipientEmail(result.email || selectedVendor.email);
        setDeleteCode("");
        setDownloadVendor(true);

        setShowDownloadVendorModal(false);
        setShowDeleteModal(true);

    } catch (error) {
        console.error("Send download OTP error:", error);
        alert(error.message || "Unable to send OTP.");
    } finally {
        setSendingDeleteCode(false);
    }
};





    return (

        <div className="vendors-page">


            {/* ---------------------------------- */}
            {/* HEADER */}
            {/* ---------------------------------- */}

            <div className="vendors-header">

                <div>

                    <h1>Vendors</h1>

                    <p>
                        Manage all vendor details
                    </p>

                </div>


                <div className="vendors-header-buttons">

                    <button
                        className="download-vendor-btn"
                        onClick={downloadVendorDetails}
                    >
                        Download
                    </button>


                    <button
                        className="add-vendor-btn"
                        onClick={() => setShowForm(!showForm)}
                    >
                        {showForm ? "x Close" : "+ Add Vendor"}
                    </button>

                </div>

            </div>


            {/* ---------------------------------- */}
            {/* ADD VENDOR FORM */}
            {/* ---------------------------------- */}

            {showForm && (

                <form
                    className="vendor-form"
                    onSubmit={handleSubmit}
                >


                    <input
                        name="vendor_name"
                        placeholder="Vendor Name"
                        value={formData.vendor_name}
                        onChange={handleChange}
                        required
                    />


                    <input
                        name="contact_person"
                        placeholder="Contact Person"
                        value={formData.contact_person}
                        onChange={handleChange}
                    />


                    <input
                        name="gst_number"
                        placeholder="GST Number/Tax ID"
                        value={formData.gst_number}
                        onChange={handleChange}
                    />


                    {/* ---------------------------------- */}
                    {/* PHONE NUMBER */}
                    {/* ---------------------------------- */}

{/* ---------------------------------- */}
{/* PHONE NUMBER */}
{/* ---------------------------------- */}

<div className="phone-input-group">

    <select
        name="phone_country_code"
        value={formData.phone_country_code}
        onChange={handleChange}
    >
        <option value="+91">IN +91</option>
        <option value="+1">US +1</option>
        <option value="+44">GB +44</option>
        <option value="+61">AU +61</option>
        <option value="+971">AE +971</option>
        <option value="+65">SG +65</option>
        <option value="+60">MY +60</option>
        <option value="+81">JP +81</option>
        <option value="+82">KR +82</option>
        <option value="+86">CN +86</option>
        <option value="+49">DE +49</option>
        <option value="+33">FR +33</option>
        <option value="+39">IT +39</option>
        <option value="+34">ES +34</option>
        <option value="+31">NL +31</option>
        <option value="+41">CH +41</option>
        <option value="+43">AT +43</option>
        <option value="+32">BE +32</option>
        <option value="+45">DK +45</option>
        <option value="+46">SE +46</option>
        <option value="+47">NO +47</option>
        <option value="+358">FI +358</option>
        <option value="+351">PT +351</option>
        <option value="+30">GR +30</option>
        <option value="+7">RU +7</option>
        <option value="+380">UA +380</option>
        <option value="+90">TR +90</option>
        <option value="+972">IL +972</option>
        <option value="+966">SA +966</option>
        <option value="+974">QA +974</option>
        <option value="+965">KW +965</option>
        <option value="+973">BH +973</option>
        <option value="+968">OM +968</option>
        <option value="+974">QA +974</option>
        <option value="+20">EG +20</option>
        <option value="+27">ZA +27</option>
        <option value="+234">NG +234</option>
        <option value="+254">KE +254</option>
        <option value="+55">BR +55</option>
        <option value="+52">MX +52</option>
        <option value="+54">AR +54</option>
        <option value="+56">CL +56</option>
        <option value="+57">CO +57</option>
        <option value="+64">NZ +64</option>
        <option value="+63">PH +63</option>
        <option value="+66">TH +66</option>
        <option value="+84">VN +84</option>
        <option value="+62">ID +62</option>
        <option value="+92">PK +92</option>
        <option value="+880">BD +880</option>
        <option value="+94">LK +94</option>
        <option value="+977">NP +977</option>
    </select>

    <input
        name="phone_number"
        placeholder="Phone Number"
        value={formData.phone_number}
        onChange={handleChange}
    />

</div>


{/* ---------------------------------- */}
{/* WHATSAPP NUMBER */}
{/* ---------------------------------- */}

<div className="phone-input-group">

    <select
        name="whatsapp_country_code"
        value={formData.whatsapp_country_code}
        onChange={handleChange}
    >
        <option value="+91">IN +91</option>
        <option value="+1">US +1</option>
        <option value="+44">GB +44</option>
        <option value="+61">AU +61</option>
        <option value="+971">AE +971</option>
        <option value="+65">SG +65</option>
        <option value="+60">MY +60</option>
        <option value="+81">JP +81</option>
        <option value="+82">KR +82</option>
        <option value="+86">CN +86</option>
        <option value="+49">DE +49</option>
        <option value="+33">FR +33</option>
        <option value="+39">IT +39</option>
        <option value="+34">ES +34</option>
        <option value="+31">NL +31</option>
        <option value="+41">CH +41</option>
        <option value="+43">AT +43</option>
        <option value="+32">BE +32</option>
        <option value="+45">DK +45</option>
        <option value="+46">SE +46</option>
        <option value="+47">NO +47</option>
        <option value="+358">FI +358</option>
        <option value="+351">PT +351</option>
        <option value="+30">GR +30</option>
        <option value="+7">RU +7</option>
        <option value="+380">UA +380</option>
        <option value="+90">TR +90</option>
        <option value="+972">IL +972</option>
        <option value="+966">SA +966</option>
        <option value="+974">QA +974</option>
        <option value="+965">KW +965</option>
        <option value="+973">BH +973</option>
        <option value="+968">OM +968</option>
        <option value="+20">EG +20</option>
        <option value="+27">ZA +27</option>
        <option value="+234">NG +234</option>
        <option value="+254">KE +254</option>
        <option value="+55">BR +55</option>
        <option value="+52">MX +52</option>
        <option value="+54">AR +54</option>
        <option value="+56">CL +56</option>
        <option value="+57">CO +57</option>
        <option value="+64">NZ +64</option>
        <option value="+63">PH +63</option>
        <option value="+66">TH +66</option>
        <option value="+84">VN +84</option>
        <option value="+62">ID +62</option>
        <option value="+92">PK +92</option>
        <option value="+880">BD +880</option>
        <option value="+94">LK +94</option>
        <option value="+977">NP +977</option>
    </select>

    <input
        name="whatsapp_number"
        placeholder="WhatsApp Number"
        value={formData.whatsapp_number}
        onChange={handleChange}
    />

</div>

                    {/* ---------------------------------- */}
                    {/* DATE */}
                    {/* ---------------------------------- */}

                    <input
                        type="date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                    />


                    {/* ---------------------------------- */}
                    {/* EMAIL */}
                    {/* ---------------------------------- */}

                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                    />


                    {/* ---------------------------------- */}
                    {/* ADDRESS */}
                    {/* ---------------------------------- */}

                    <input
                        name="address"
                        placeholder="Address"
                        value={formData.address}
                        onChange={handleChange}
                    />


                    {/* ---------------------------------- */}
                    {/* CITY */}
                    {/* ---------------------------------- */}

                    <input
                        name="city"
                        placeholder="City"
                        value={formData.city}
                        onChange={handleChange}
                    />


                    {/* ---------------------------------- */}
                    {/* STATE */}
                    {/* ---------------------------------- */}

                    <input
                        name="state"
                        placeholder="State"
                        value={formData.state}
                        onChange={handleChange}
                    />


                    {/* ---------------------------------- */}
                    {/* COUNTRY */}
                    {/* ---------------------------------- */}

                    <input
                        name="country"
                        placeholder="Country"
                        value={formData.country}
                        onChange={handleChange}
                    />


                    {/* ---------------------------------- */}
                    {/* PINCODE */}
                    {/* ---------------------------------- */}

                    <input
                        name="pincode"
                        placeholder="Pincode"
                        value={formData.pincode}
                        onChange={handleChange}
                    />


                    {/* ---------------------------------- */}
                    {/* SAVE */}
                    {/* ---------------------------------- */}

                    <button type="submit">
                        Save Vendor
                    </button>

                </form>

            )}


            {/* ---------------------------------- */}
            {/* VENDOR TABLE */}
            {/* ---------------------------------- */}

            <div className="vendor-table-container">

                {loading ? (

                    <p>Loading vendors...</p>

                ) : vendors.length === 0 ? (

                    <p>No vendor details found.</p>

                ) : (

                    <table className="vendor-table">

                        <thead>

                            <tr>

                                <th>Vendor ID</th>

                                <th>GST Number</th>

                                <th>Vendor Name</th>

                                <th>Contact Person</th>

                                <th>Phone</th>

                                <th>WhatsApp</th>

                                <th>Email</th>

                                <th>Address</th>

                                <th>City</th>

                                <th>State</th>

                                <th>Country</th>

                                <th>Pincode</th>

                                <th>Date</th>

                                <th>Action</th>

                            </tr>

                        </thead>


                        <tbody>

                            {vendors.map((vendor) => (

                                <tr key={vendor.vendor_id}>

                                    <td>
                                        <strong>
                                            {vendor.vendor_id}
                                        </strong>
                                    </td>


                                    <td>
                                        {vendor.gst_number || "-"}
                                    </td>


                                    <td>
                                        {vendor.vendor_name}
                                    </td>


                                    <td>
                                        {vendor.contact_person || "-"}
                                    </td>


                                    <td>
                                        {vendor.phone_number || "-"}
                                    </td>


                                    <td>
                                        {vendor.whatsapp_number || "-"}
                                    </td>


                                    <td>
                                        {vendor.email || "-"}
                                    </td>


                                    <td>
                                        {vendor.address || "-"}
                                    </td>


                                    <td>
                                        {vendor.city || "-"}
                                    </td>


                                    <td>
                                        {vendor.state || "-"}
                                    </td>


                                    <td>
                                        {vendor.country || "-"}
                                    </td>


                                    <td>
                                        {vendor.pincode || "-"}
                                    </td>


                                    <td>
                                        {vendor.date || "-"}
                                    </td>


                                    <td>

                                        <button
                                            className="delete-btn"
                                            onClick={() =>
                                                deleteVendor(
                                                    vendor.vendor_id
                                                )
                                            }
                                        >
                                            Delete
                                        </button>

                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </table>

                )}

            </div>



{/* =========================================
    DOWNLOAD VENDOR SELECTION MODAL
========================================= */}

{showDownloadVendorModal && (

    <div className="delete-modal-overlay">

        <div className="delete-modal">

            <h2>
                Select Vendor
            </h2>

            <p>
                Select the vendor whose registered email
                should receive the verification OTP.
            </p>

            <select
                value={selectedDownloadVendor}
                onChange={(e) =>
                    setSelectedDownloadVendor(e.target.value)
                }
                className="download-vendor-select"
            >

                <option value="">
                    -- Select Vendor --
                </option>

                {vendors.map((vendor) => (

                    <option
                        key={vendor.vendor_id}
                        value={vendor.vendor_id}
                    >
                        {vendor.vendor_name}
                    </option>

                ))}

            </select>


            <div className="delete-modal-buttons">

                <button
                    type="button"
                    className="cancel-delete-btn"
                    onClick={() => {

                        setShowDownloadVendorModal(false);
                        setSelectedDownloadVendor("");

                    }}
                    disabled={sendingDeleteCode}
                >
                    Cancel
                </button>


                <button
                    type="button"
                    className="verify-delete-btn"
                    onClick={sendDownloadOTP}
                    disabled={
                        sendingDeleteCode ||
                        !selectedDownloadVendor
                    }
                >
                    {sendingDeleteCode
                        ? "Sending OTP..."
                        : "Send OTP"
                    }
                </button>

            </div>

        </div>

    </div>

)}
{/* =========================================
    DELETE VERIFICATION MODAL
========================================= */}

{showDeleteModal && (

    <div className="delete-modal-overlay">

        <div className="delete-modal">

            <h2>
                Verify OTP
            </h2>


           <p>
    A 6-digit verification code has been sent to the
    selected vendor's registered email:
</p>

           <strong>
    {deleteRecipientEmail || "the vendor's registered email"}
</strong>

            <p className="delete-modal-info">
                Open your Gmail, copy the code,
                then return here and enter it below.
            </p>


            <input
                type="text"
                inputMode="numeric"
                maxLength="6"
                placeholder="Enter 6-digit code"
                value={deleteCode}
                onChange={(e) => {

                    const value =
                        e.target.value.replace(
                            /\D/g,
                            ""
                        );

                    setDeleteCode(value);

                }}
                autoFocus
            />


            <div className="delete-modal-buttons">

                <button
                    type="button"
                    className="cancel-delete-btn"
                    onClick={() => {
    setShowDeleteModal(false);
    setDeleteCode("");
    setDeleteVendorId(null);
    setDeleteRecipientEmail("");
    setDownloadVendor(false);
}}
                    disabled={deletingVendor}
                >
                    Cancel
                </button>


           <button 
    type="button" 
    className="verify-delete-btn" 
    onClick={verifyDeleteCode} 
    disabled={
        deletingVendor ||
        downloadingVendors ||
        deleteCode.length !== 6
    } 
>
    {downloadVendor
        ? (
            downloadingVendors
                ? "Downloading..."
                : "Verify & Download"
        )
        : (
            deletingVendor
                ? "Deleting..."
                : "Verify & Delete"
        )
    }
</button>
            </div>

        </div>

    </div>

)}
        </div>
    );
};

export default Vendors;